import { CoreModel } from '../core/core.model';
import { InputModel } from '../input/input.model';
export class DatatableFilterModel extends CoreModel {
/**
 * CfInput component for the filter. Optional.
 */
inputProperty?: InputModel;
/**
 * @hidden 
 * It is the constructor for the Datatable component. It takes the values from component to create the Datatable object.
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function DatatableFilterModel_tsickle_Closure_declarations() {
/**
 * CfInput component for the filter. Optional.
 * @type {?}
 */
DatatableFilterModel.prototype.inputProperty;
}

